export default function Updater(): null {
  // keep dark mode in sync with the system
  return null
}
